import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardHeader, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './cameralist.css';
import {getData} from '../../api/doLogin.js';
import {checkPerms} from '../../api/permissions.js';
import './xterm.css';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {Player} from 'video-react';
import "video-react/dist/video-react.css";
import {postData} from "../../api/doLogin";
import {LMSUserPicker} from "../../components/LMSUserPicker/LMSUserPicker";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export class MediaList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {}
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 50,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.accessLevel = 1;
  }

  componentDidMount() {
    this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type) {
      this.updateData();
    }
  }

  reBuildObject(camera_id, dated) {
    var self = this;
    postData(`camera/video/${camera_id}/${dated}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.updateData();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getObject(camera_id, dated, type) {
    var self = this;
    getData(`camera/video/${camera_id}/${dated}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.setState({preview: data.data});
        }
      })
      .catch(error => {
        console.error(error);
      });
    console.log(camera_id, dated, type);
  }

  updateData() {
    var self = this;
    getData(`camera/media${this.props['match']['params']['uuid'] ? "/" + this.props['match']['params']['uuid'] : ""}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.setState({data: data.data.mediaList, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  saveNotes(uuid, dated, note) {
    var self = this;
    postData(`camera/media/${uuid}/${dated}/update`, {notes: note}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          const curList = self.state.data;
          curList.map((entry, ind) => {
            if (entry.camera_id === uuid && entry.dated === dated) {
              curList[ind]['notes'] = note;
            }
          });
          self.setState({data: curList});
        }
      }).catch(error => {
      console.error(error);
    });
  }

  saveLMSId(uuid, dated, lms) {
    var self = this;
    postData(`camera/media/${uuid}/${dated}/update`, {lmsId: lms.id}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          const curList = self.state.data;
          curList.map((entry, ind) => {
            if (entry.camera_id === uuid && entry.dated === dated) {
              curList[ind]['lms_id'] = lms.id;
              curList[ind]['lms_name'] = `${lms.fname} ${lms.lname}`.trim();
            }
          });
          self.setState({data: curList, showPicker: false, tempData:{}});
        }
      }).catch(error => {
      console.error(error);
    });
  }

  noteFormatter(cell, row, self) {
    return (
      <Fragment>
        <span>{row['lms_id'] !== "0" ? `${row['lms_name']} ${cell}` : `${cell}`}</span>
        <Button onClick={(evt) => {
          setTimeout(() => {
            const note = window.prompt("Recording Note", cell);
            if (note !== null) {
              self.saveNotes(row['camera_id'], row['dated'], note);
            }

          }, 10);
        }}>Edit</Button>
      </Fragment>
    );
  }

  actionFormatter(cell, row, self) {
    if (row['status'] === "processing") {
      return "Working...";
    } else if (row['status'] !== "processed" && row['status'] !== "captured") {
      if (self.accessLevel === 3 && row['type'] === "record") {
        return <Button
          onClick={() => {
            this.reBuildObject(row['camera_id'], row['dated']);
          }}
        >Process</Button>
      } else {
        return "Please wait..."
      }
    } else {
      return <Fragment>
        <Button
          onClick={() => {
            this.getObject(row['camera_id'], row['dated'], row['type']);
          }}
        >View</Button>
        {this.accessLevel === 3 && row['type'] === "record" && (
          <Button
            onClick={() => {
              this.reBuildObject(row['camera_id'], row['dated']);
            }}
          >Re-process</Button>
        )}
        <Button onClick={() => this.setState({
          showPicker: true,
          tempData: {cameraId: row['camera_id'], dated: row['dated']}
        })}>LMS</Button>
      </Fragment>
    }
  }

  render() {
    const getType = (type) => {
      switch (type) {
        case "still":
          return "Still Image";
        case "record":
          return "Recording";
        default:
      }
    }
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"></i>Media
              <div className="card-actions">
                <button onClick={() => this.props.history.push(`/cameras`)}>
                  <small className="text-muted">Back</small>
                </button>
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <BootstrapTable data={this.state.data} version="4" striped hover pagination search options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="date_time" dataSort dataFormat={(cell, row) => {
                  return cell.split(".")[0].replace("T", " ");
                }}
                >Start Date</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="type"
                  dataSort
                  dataFormat={(cell, row) => getType(cell)}
                >Type</TableHeaderColumn>
                <TableHeaderColumn dataField="status" dataSort>Status</TableHeaderColumn>
                <TableHeaderColumn dataField="notes"
                                   dataFormat={(cell, row) => this.noteFormatter(cell, row, this)}>Notes</TableHeaderColumn>
                <TableHeaderColumn dataField="button"
                                   dataFormat={(cell, row) => this.actionFormatter(cell, row, this)}
                >Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
          </Card>
        )}

        <Modal isOpen={this.state.preview !== null}
               className={'modal-lg ' + this.props.className}>
          <ModalHeader>Preview</ModalHeader>
          <ModalBody>
            {this.state.preview && this.state.preview['type'] === "still" && (
              <div>
                <img src={this.state.preview['url']} width="100%" height="100%"/>
              </div>
            )}
            {this.state.preview && this.state.preview['type'] === "record" && (
              <div style={{height: "100%"}}>
                <Player
                  playsInline
                  src={this.state.preview['url']}
                />
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <span>Link expires in 30 minutes</span>
            <Button color="primary"
                    onClick={() => window.open(this.state.preview['url'])}>Download</Button>
            <Button color="secondary"
                    onClick={() => this.setState({preview: null})}>Close</Button>
          </ModalFooter>
        </Modal>
        <LMSUserPicker
          isOpen={this.state.showPicker}
          onClose={() => this.setState({showPicker: false, tempData:{}})}
          onSelect={(lead) => this.saveLMSId(this.state.tempData['cameraId'],this.state.tempData['dated'], lead)}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Camera/MediaList.js